import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";
import { ICourseCategory } from "../../../feature-module/pages/masters/courseCategories";

interface ICourseCategoriesState {
  data: ICourseCategory[];
  loading: boolean;
  error: string | null;
  total: number;
  page: number;
  limit: number;
}

const initialState: ICourseCategoriesState = {
  data: [],
  loading: false,
  error: null,
  total: 0,
  page: 1,
  limit: 10,
};

export const getAllCourseCategories = createAsyncThunk(
  'get/allCourseCategories',
  async (payload: any, thunkAPI) => {
    try {
      const response = await Api.post(
        API_URLS.MASTERS.FIND_ALL_COURSE_CATEGORIES,
        payload
      );
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
    }
  }
);

const courseCategoriesSlice = createSlice({
  name: "courseCategories",
  initialState,
  reducers: {
    resetCourseCategoriesState: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.total = 0;
      state.page = 1;
      state.limit = 10;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllCourseCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCourseCategories.fulfilled, (state, action) => {
        const payload = action.payload;
        state.loading = false;
        state.data = payload.data || [];
        state.total = payload.total || 0;
      })
      .addCase(getAllCourseCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.data = [];
      });
  },
});

export const { resetCourseCategoriesState } = courseCategoriesSlice.actions;
export default courseCategoriesSlice.reducer;